import React from "react";
import { Link } from "react-router-dom";
import { Star, MessageCircle, ArrowRight } from "lucide-react";
import { waHref } from "./utils";

export default function FinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-950 via-slate-900 to-slate-950 border-t border-slate-800">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <Star className="mx-auto text-amber-400 mb-4" size={30} fill="#fbbf24" />
        <h2 className="font-heading text-4xl md:text-5xl font-black uppercase">Ready to broadcast?</h2>
        <p className="text-slate-300 mt-4 max-w-xl mx-auto">
          Message us on WhatsApp. We'll activate your account in under 5 minutes and walk you through your first match.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <a href={waHref("Hi! I want to try Cricket Graphics Studio. Please help me get started.")}
            target="_blank" rel="noreferrer" data-testid="final-wa-cta"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-lg bg-emerald-600 hover:bg-emerald-700 font-bold text-lg shadow-lg shadow-emerald-900/50">
            <MessageCircle size={18} /> Start on WhatsApp
          </a>
          <Link to="/login" data-testid="final-signin"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-700 font-semibold">
            I already have an account <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
